import React, { useState } from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Card,
  CardContent,
  CardActions,
  IconButton,
  CircularProgress,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ClassIcon from '@mui/icons-material/Class';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Header } from '../components/Header';
import { UsuariListButton } from '../components/UsuariListButton.jsx';
import { STPButton } from '../components/Botones';
import { useTranslation } from 'react-i18next';
import { fetchGruposRecursos, fetchRecursosByGrupo } from '../services/recursos';

export function Recursos({ setIsAuthenticated }) {
  const { t, i18n } = useTranslation();
  const [showGroupSelection, setShowGroupSelection] = useState(true);
  const [selectedGrupo, setSelectedGrupo] = useState(null);
  const [grupos, setGrupos] = useState([]);
  const [recursos, setRecursos] = useState([]);
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    fetchGruposRecursos().then(setGrupos);
  }, []);

  const handleGrupoSelect = async (id) => {
    setSelectedGrupo(id);
    setShowGroupSelection(false);
    setLoading(true);
    const recursos = await fetchRecursosByGrupo(id);
    setRecursos(recursos);
    setLoading(false);
  };

  const handleGoBack = () => {
    setSelectedGrupo(null);
    setShowGroupSelection(true);
    setRecursos([]);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', width: '100%' }}>
      <Header setIsAuthenticated={setIsAuthenticated} />
      <Box sx={{ p: 2, maxWidth: 600, mt: 2, flexGrow: 1 }}>
        {showGroupSelection ? (
          <>
            <Typography variant="h4" sx={{ mb: 4, color: "black", textAlign: "center" }}>
              {t('resourceSelection.select')} <span style={{ color: '#50A579' }}>{t('resourceSelection.group')}</span>
            </Typography>
            <List sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}>
              {grupos.map((grupo) => (
                <ListItem key={grupo.id} disablePadding>
                  <UsuariListButton
                    onClick={() => handleGrupoSelect(grupo.id)}
                    sx={{ width: '100%', justifyContent: 'flex-start' }}
                  >
                    <ListItemIcon>
                      <ClassIcon sx={{ color: '#50A579' }} />
                    </ListItemIcon>
                    <ListItemText primary={grupo.nombre} />
                  </UsuariListButton>
                </ListItem>
              ))}
            </List>
          </>
        ) : (
          <>
            <Typography variant="h4" sx={{ mb: 4, textAlign: 'center', color: 'black' }}>
              {t('resourceSelection.select')} <span style={{ color: '#50A579' }}>{t('resourceSelection.resource')}</span>
            </Typography>
            <IconButton
                aria-label="back"
                onClick={handleGoBack}
                sx={{ mb: 3 }}
            >
                <ArrowBackIcon /> <Typography sx={{ ml: 2 }} variant="body1">{t('resourceSelection.back')}</Typography>
            </IconButton>
            {loading ? (
              (<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                <CircularProgress sx={{ 
                    color: 'rgba(80, 165, 121, 0.7)',
                    }}/>
                </Box>)
            ) : recursos.length === 0 ? (
              <Typography align="center" sx={{ mt: 4 }}>
                {i18n.language.startsWith('ca')
                  ? 'No hi ha recursos disponibles.'
                  : 'No hay recursos disponibles.'}
              </Typography>
            ) : (
              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr', gap: 2 }}>
                {recursos.map((recurso) => (
                  <Card key={recurso.id} sx={{ boxShadow: 3, width: '100%' }}>
                    <CardContent>
                      <Typography variant="h6">{recurso.titulo}</Typography>
                    </CardContent>
                    <CardActions sx={{ justifyContent: 'flex-end', pb: 2, pr: 2 }}>
                      <STPButton onClick={() => window.open(recurso.url, '_blank', 'noopener')}>
                        {t('resourceSelection.open')} <OpenInNewIcon sx={{ ml: 1 }} />
                      </STPButton>
                    </CardActions>
                  </Card>
                ))}
              </Box>
            )}
          </>
        )}
      </Box>
    </Box>
  );
}
